export default "__VITE_ASSET__BRGIUpm6__"